"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.confirmFooterStyles = exports.confirmBodyStyles = exports.confirmStyles = void 0;

var _styledComponents = require("styled-components");

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var _stylers = _interopRequireDefault(require("@paprika/stylers"));

var confirmStyles = (0, _styledComponents.css)(["padding:0 ", " ", " ", ";"], _tokens["default"].spaceSm, _tokens["default"].space, _tokens["default"].spaceSm);
exports.confirmStyles = confirmStyles;
var confirmBodyStyles = (0, _styledComponents.css)(["", " padding:", " 0 0 0;"], _stylers["default"].lineHeight(), _tokens["default"].spaceSm);
exports.confirmBodyStyles = confirmBodyStyles;
var confirmFooterStyles = (0, _styledComponents.css)(["margin-top:", ";[role=\"button\"] + [role=\"button\"]{margin-left:", ";}"], _stylers["default"].spacer(2), _tokens["default"].space);
exports.confirmFooterStyles = confirmFooterStyles;
//# sourceMappingURL=Confirmation.styles.js.map